module.exports = __webpack_public_path__ + "img/sq-bg4.2761262c.png";